import { Box, Button, OutlinedInput } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

import { useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import SearchLoader from '../SearchLoader';

const Toolbar = ({
  route,
  filterItem,
  searchLoader,
  handleCloseModal,
  text,
  hideFilter,
  searchInputRef,
  hideAddButton = false,
  ...props
}) => {
  const navigate = useNavigate();
  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '17%'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <OutlinedInput
              size="small"
              id="search"
              fullWidth
              type="text"
              ref={searchInputRef}
              placeholder="Search"
              startAdornment={
                <SearchIcon sx={{ height: '20px', color: '#a5aebb' }} />
              }
              endAdornment={searchLoader && <SearchLoader />}
              onChange={(e) => {
                filterItem(e.target.value);
              }}
            />
            {!hideFilter && (
              <Box
                sx={{ cursor: 'pointer', marginLeft: '5px' }}
                onClick={() => {
                  handleCloseModal();
                }}
              >
                <FilterListIcon fontSize='large' color='action' />
              </Box>
            )}
          </Box>
        </Box>
        {!hideAddButton && <Button
          sx={{
            textTransform: 'none',
            transition: '.5s',
            height: '80%',
            opacity: '.9',
            '&:hover': {
              opacity: '1',
              transform: 'scale(.9)'
            }
          }}
          color="primary"
          variant="contained"
          onClick={() => navigate(route)}
        >
          {text}
        </Button>}
      </Box>
    </Box>
  );
};

export default Toolbar;
